import { z } from "zod";
import { BookLanguageSchema, TtsModelSchema } from "./states";

export const VoiceLibraryQuerySchema = z.strictObject({
  language: BookLanguageSchema,
  model: TtsModelSchema.default("eleven_v3"),
  search: z.string().trim().max(150).default(""),
  accent: z.string().trim().max(80).default(""),
  gender: z.enum(["", "male", "female", "neutral"]).default(""),
  age: z.enum(["", "young", "middle_aged", "old"]).default(""),
  useCase: z.string().trim().max(80).default(""),
  sort: z
    .enum(["usage_character_count_1y", "trending", "created_date", "cloned_by_count"])
    .default("usage_character_count_1y"),
  includeHigherRates: z.enum(["true", "false"]).default("false"),
  page: z.coerce.number().int().min(0).max(10000).default(0),
});
export type VoiceLibraryQuery = z.infer<typeof VoiceLibraryQuerySchema>;
export const VoiceLibraryEntrySchema = z.object({
  providerId: z.string(),
  ownerId: z.string(),
  name: z.string(),
  language: z.string().nullable(),
  supportedLanguages: z.array(z.string()),
  accent: z.string().nullable(),
  gender: z.string().nullable(),
  age: z.string().nullable(),
  description: z.string().nullable(),
  useCase: z.string().nullable(),
  previewUrl: z.string().nullable(),
  previewLanguage: z.string().nullable(),
  previewModel: z.string().nullable(),
  rate: z.number().positive().nullable(),
  recommended: z.boolean(),
  available: z.boolean(),
});
export type VoiceLibraryEntry = z.infer<typeof VoiceLibraryEntrySchema>;
export const VoiceLibraryResponseSchema = z.object({
  voices: z.array(VoiceLibraryEntrySchema),
  hasMore: z.boolean(),
  totalCount: z.number().nullable(),
});
export type VoiceLibraryResponse = z.infer<typeof VoiceLibraryResponseSchema>;
export const VoiceImportSchema = z.strictObject({
  providerId: z.string().regex(/^[a-zA-Z0-9]{10,80}$/),
  ownerId: z.string().regex(/^[a-zA-Z0-9]{10,150}$/),
});
export interface VoiceLibraryMetadata {
  ownerId: string;
  languages: string[];
  rate: number | null;
  available: boolean;
  checkedAt: string;
}
